module.exports = [
  require('./green_flame_blade_scag'),
]
